<div class="padded-container">
  <dx-button text="{{ 'Voucher' | translate }}" type="default"
  class="full-width-button" (onClick)="navigateToVoucher()"></dx-button>
  <dx-button text="{{ 'Service' | translate }}"type="default"
  class="full-width-button" (onClick)="navigateToService()"></dx-button>
</div>